// Professional Loading Screen component for GenerateAIPage
import React, { useState, useEffect } from "react";

const travelTips = [
  "Did you know? Packing light makes travel easier and more fun!",
  "Tip: Always keep digital copies of your travel documents.",
  "Explore local cuisine for a true taste of your destination!",
  "Travel fact: Smiling is the universal language.",
  "Pro tip: Early mornings are the best for sightseeing.",
  "Remember to stay hydrated and take lots of photos!",
  "Adventure awaits – let AI do the planning!",
  "Travel is the only thing you buy that makes you richer.",
  "Sometimes the best moments are unplanned!"
];

const LoadingScreen = () => {
  const [tipIndex, setTipIndex] = useState(0);
  const [dotCount, setDotCount] = useState(1);

  useEffect(() => {
    const tipInterval = setInterval(() => {
      setTipIndex((prev) => (prev + 1) % travelTips.length);
    }, 3500);
    return () => clearInterval(tipInterval);
  }, []);

  useEffect(() => {
    const dotInterval = setInterval(() => {
      setDotCount((prev) => (prev % 3) + 1);
    }, 600);
    return () => clearInterval(dotInterval);
  }, []);

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-gradient-to-br from-blue-100 via-blue-300 to-blue-500/60 dark:from-zinc-900 dark:via-blue-900 dark:to-blue-800/70 backdrop-blur-[2px] animate-fade-in">
      <div className="bg-white/95 dark:bg-zinc-900/95 rounded-3xl shadow-2xl px-10 py-10 flex flex-col items-center gap-6 border border-blue-200 dark:border-blue-800 backdrop-blur-xl animate-fade-in-card min-w-[340px] max-w-xs sm:max-w-md">
        {/* Animated Plane Mascot */}
        <div className="relative w-24 h-20 flex items-center justify-center mb-2">
          <svg className="absolute left-0 right-0 mx-auto w-20 h-14 animate-plane-bounce" viewBox="0 0 64 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g>
              <path d="M59 9L5 29l13 5 7 17 7-13 13 5 14-34z" fill="#2563eb" stroke="#0a2540" strokeWidth="2"/>
              <circle cx="53" cy="15" r="2" fill="#fff"/>
            </g>
          </svg>
        </div>
        <h2 className="text-xl font-black text-blue-700 dark:text-white tracking-wide text-center drop-shadow mb-1">Generating your itinerary<span className="inline-block text-2xl ml-1 align-middle" aria-label="loading">{".".repeat(dotCount)}</span></h2>
        <div className="w-full flex flex-col items-center">
          <div className="text-blue-500 dark:text-blue-300 text-center text-base font-medium min-h-[54px] flex flex-col items-center transition-all duration-700 animate-fade-in-tip">
            <svg className="inline w-5 h-5 mr-1 mb-1 text-blue-400 animate-pulse" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M13 16h-1v-4h-1m1-4h.01M12 20a8 8 0 100-16 8 8 0 000 16z" /></svg>
            <span>{travelTips[tipIndex]}</span>
          </div>
        </div>
        {/* Progress Dots */}
        <div className="flex gap-2 mt-2" aria-label="progress">
          {[0,1,2].map(i => (
            <span key={i} className={`w-3 h-3 rounded-full transition-all duration-300 ${i < dotCount ? 'bg-blue-500' : 'bg-blue-200 dark:bg-zinc-700'}`}></span>
          ))}
        </div>
      </div>
      <style>{`
        .animate-plane-bounce { animation: planeBounce 1.6s infinite cubic-bezier(.4,0,.2,1) alternate; }
        @keyframes planeBounce { 0% { transform: translateY(0) scale(1.04); } 60% { transform: translateY(-14px) scale(1.08); } 100% { transform: translateY(0) scale(1.04); } }
        .animate-fade-in-card { animation: fadeInCard 0.8s cubic-bezier(.4,0,.2,1) both; }
        @keyframes fadeInCard { 0% { opacity: 0; transform: translateY(40px);} 100% { opacity: 1; transform: translateY(0);}}
        .animate-fade-in { animation: fadeIn 0.7s cubic-bezier(.4,0,.2,1) both; }
        @keyframes fadeIn { 0% { opacity: 0; } 100% { opacity: 1; } }
        .animate-fade-in-tip { animation: fadeInTip 1s cubic-bezier(.4,0,.2,1); }
        @keyframes fadeInTip { 0% { opacity: 0; transform: translateY(20px);} 100% { opacity: 1; transform: translateY(0);}}
      `}</style>
    </div>
  );
};

export default LoadingScreen;
